<template>
    <select><slot></slot></select>
</template>

<script>
    import 'select2/dist/js/select2.full';
    import initSelect2Title from '../select2-title';

    export default {
        props: ["options", "value", "disabled", "config", "id-format", "text-format", "selected-format", "disabled-format", "close-on-deselect"],
        data() {
            return {
                cfg: null,
                lookup: new Object(),
                multiple: false
            }
        },
        methods: {
            initConfig: function (options) {
                this.cfg = this.config ? this.config : {};
                this.cfg.data = this.formatOptions(options ? options : this.options);
                if (this.cfg.multiple) {
                    this.multiple = true;
                }
            },
            formatOptions: function (options) {
                var vm = this;
                if (!vm.idFormat && !vm.textFormat && !vm.selectedFormat && !vm.disabledFormat) {
                    // no customization needs to be done
                    return options;
                } else {
                    var clone = _.clone(options);

                    // recursively call on results if they exist (in the case of added pagination)
                    if (options.results) {
                        clone.results = vm.formatOptions(options.results);
                        return clone;
                    }

                    // recursively call on children if they exist (in the case of groupings)
                    else if (options.children) {
                        clone.children = vm.formatOptions(options.children);
                        return clone;
                    }

                    // recursively call on items if they are in an array
                    else if (Array.isArray(options)) {
                        return _.map(options, function (o) {
                            return vm.formatOptions(o);
                        });
                    }

                    // in a custom object, format it!
                    else {
                        return {
                            id: vm.idFormat ? vm.idFormat(options) : options.id,
                            text: vm.textFormat ? vm.textFormat(options) : options.text,
                            selected: vm.selectedFormat ? vm.selectedFormat(options) : options.selected,
                            disabled: vm.disabledFormat ? vm.disabledFormat(options) : options.disabled
                        };
                    }
                }
            },
            createLookup: function (options) {
                var vm = this;
                if (options.results) {
                    vm.createLookup(options.results);
                }
                else if (options.children) {
                    vm.createLookup(options.children);
                }
                else if (Array.isArray(options)) {
                    _.forEach(options, function (o) {
                        vm.createLookup(o);
                    });
                } else {
                    var id = vm.idFormat ? vm.idFormat(options) : options.id;
                    vm.lookup[id] = options;
                }
            },
            findItem: function (id) {
                if (this.lookup) {
                    return this.lookup[id];
                } else {
                    return null;
                }
            },
            valChanged: function (newVal, changedViaSelect) {
                // TODO: CLEAN THIS UP NOW THAT IT'S BEEN HACKED TO WORK WITH MULTIPLE VALUES
                // if value is an object, get the corresponding ID
                var vm = this;
                var id;
                if (vm.multiple) {
                    id = _.map(newVal, function (v) {
                        if (typeof (v) === 'object') {
                            return vm.idFormat ? vm.idFormat(v) : v.id;
                        } else {
                            return v;
                        }
                    });
                } else {
                    if (!!newVal && typeof (newVal) === 'object') {
                        id = vm.idFormat ? vm.idFormat(newVal) : newVal.id;
                    } else {
                        id = newVal;
                    }
                }
                // update the select, but only if it was modified externally
                if (!changedViaSelect) {
                    $(vm.$el).val(id);
                    $(vm.$el).trigger("change.select2");
                }
            }
        },
        mounted: function () {
            var vm = this;

            if (vm.options) {
                vm.initConfig();

                vm.createLookup(vm.options);
            }

            $(vm.$el)
                // init select2
                .select2(vm.cfg)
                //.val(this.idFormat ? this.idFormat(vm.value) : vm.value)
                .val(vm.multiple ?
                    _.each(vm.value, function (v) {
                        return vm.idFormat ? vm.idFormat(v) : v;
                    }) : (vm.idFormat ? vm.idFormat(vm.value) : vm.value))
                .trigger("change")
                // emit event on change.
                .on("change", function () {
                    // TODO: CLEAN THIS UP NOW THAT IT'S BEEN HACKED TO WORK WITH MULTIPLE VALUES
                    var selectedVal = $(this).select2("data");
                    var changedVal = null;
                    if (selectedVal && selectedVal.length > 0) {
                        if (vm.multiple) {
                            changedVal = $.map(selectedVal, function (v) {
                                return vm.idFormat ? vm.findItem(v.id) : v.id;
                            });
                        } else {
                            changedVal = (vm.idFormat ? vm.findItem(selectedVal[0].id) : selectedVal[0].id);
                        }
                    }
                    //var changedVal = (vm.idFormat ? vm.findItem(this.value) : this.value);
                    //var changedVal = (vm.idFormat ? vm.findItem(selectedVal) : selectedVal);
                    vm.$emit("input", changedVal);
                    vm.valChanged(changedVal, true);
                });
            initSelect2Title($(vm.$el));

            if (vm.value) {
                vm.valChanged(vm.value, false);
            }

            // Select2 4.0 incorrectly toggles the dropdown when clearing and removing options.
            // Fix this by canceling the select2:opening/closing events that occur immediately after a select2:unselect event.
            // taken from https://github.com/select2/select2/issues/3320
            if (vm.closeOnDeselect) {
                $(this.$el).on('select2:unselect', function () {
                    var element = $(this);
                    function cancelAndRemove(event) {
                        event.preventDefault();
                        removeEvents();
                    }

                    function removeEvents() {
                        element.off('select2:opening', cancelAndRemove);
                        element.off('select2:closing', cancelAndRemove);
                    }

                    element.on('select2:opening', cancelAndRemove);
                    element.on('select2:closing', cancelAndRemove);
                    setTimeout(removeEvents, 0);
                });
            }

            // automatically focus the search box when the dropdown opens
            // adapted from https://stackoverflow.com/a/67691578
            $(this.$el).on('select2:open', (e) => {
                var resultsKey = $(e.target).next('.select2').find('.select2-selection').attr('aria-owns');

                $(`.select2-search__field[aria-controls='${resultsKey}']`).each(function (key, value) {
                    value.focus();
                });
            });
        },
        watch: {
            value: function (newVal) {
                this.valChanged(newVal, false);
            },
            options: function (options) {
                // update options
                this.initConfig(options);
                this.lookup = new Object();
                this.createLookup(options);
                $(this.$el).empty().select2(this.cfg);
                //$(this.$el).val(null).trigger("change.select2");

                // if value is still present in options, select it
                this.valChanged(this.value);
            }
        },
        unmounted: function () {
            $(this.$el).off().select2("destroy");
        }
    }
</script>

<style src="select2/dist/css/select2.min.css"></style>